import React from "react";
import { Row, Col } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import InputField from "@frameworks/web/components/generic/inputField";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import di from "../di/servicelocator";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import { useNavigate, } from "react-router-dom";
import { useSelector } from "react-redux";
import { loginHelp } from "../LogintextConfig";
import { alphaNumExp } from "@frameworks/web/utils/regex";
import * as URLConfig from "@frameworks/web/config/domain";
import { ClientChooseLoginAccount } from "./ClientChooseLoginAccount";
import { LogInWelcomePage } from "./logInWelcomePage";
import { ClientLoginOtp } from "./ClientLoginOtp";
import { getQueryParameterName } from "@frameworks/web/utils/urlHelper";
import GuestLogin from "../GuestUser/GuestLogin";
import { handleNavigateUrl, loginScreenState } from "../constant";
const config = URLConfig.config;
export const LogInMainPage = (props) => {
    const redirectUrlFromQueryParams = getQueryParameterName("redirectUrl");
    const device = DeviceContext();
    let navigate = useNavigate();
    const [userId, setUserId] = React.useState();
    const [accType, setAccType] = React.useState("");
    const [screenState, setScreenState] = React.useState(loginScreenState.LOGIN);
    const [otpStateObj, setOtpStateObj] = React.useState();
    const [loginButtonDisable, setLoginDisable] = React.useState(false);
    const [AccStorageuserID, setAccStorageuserID] = React.useState();
    const guestValidateMpin = useSelector((state) => state.LoginFlow.guestValidateMPIN.data);
    const { data: accountDetails, loader: accountDetailsLoader, errorData: accountDetailsError, } = useSelector((state) => state.LoginFlow.ClientLoginDataReducers);
    const getImageData = () => {
        di.login.flushLoginError();
        di.login.getImage({ userId });
    };
    const HandleError = () => {
        switch (accountDetailsError.error.getErrCd()) {
            case "EGN0011":
                localStorage.clear(), navigate(0);
            case "ELGN0014":
                return (React.createElement("div", { className: "invalidMsg" },
                    React.createElement("label", { className: "DMSansNormal_12_400 txt_bloodRed d-flex align-items-center" },
                        React.createElement("span", { className: "edel-icon-validation" }),
                        React.createElement("span", { className: "p-1" }, loginHelp.invalidID))));
            default:
                return (React.createElement("div", { className: "invalidMsg" },
                    React.createElement("label", { className: "DMSansNormal_12_400 txt_bloodRed d-flex align-items-center" },
                        React.createElement("span", { className: "edel-icon-validation" }),
                        React.createElement("span", { className: "p-1" }, accountDetailsError.error.getErrorMessageOrErrMsg()))));
        }
    };
    const handleChange = (event) => {
        setUserId(event.target.value.toUpperCase());
        if (loginButtonDisable) {
            setLoginDisable(false);
        }
    };
    const handleScreens = () => {
        switch (screenState) {
            case loginScreenState.LOGIN:
                return (React.createElement("div", { className: "clientLogin p-0" },
                    React.createElement("div", { className: "logInMainPage pb-100 pt-mob-15" },
                        React.createElement(GridContainer, null,
                            !(device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement(React.Fragment, null,
                                React.createElement(Row, { className: "m-0 pb-30" },
                                    React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "DMSansBold_20_700 txt-midnight-blue " }, "Login")))),
                            React.createElement("form", { id: "clientLogin_form", className: "dropdownInput", onSubmit: (e) => {
                                    e.preventDefault();
                                    getImageData();
                                } },
                                React.createElement(Row, { className: "clientLogin_inputfield mt-91" },
                                    React.createElement(Col, { lg: 12 },
                                        React.createElement(Dropdown, null,
                                            React.createElement(Dropdown.Toggle, { className: `equitydrop ${loginButtonDisable && "RedBorder"}` },
                                                React.createElement(InputField, { placeholder: "Enter your login ID", id: "name", name: "name", required: false, autoComplete: "off", defaultValue: userId && userId, onChangeEvent: (e) => handleChange(e), showLabel: true, placeholderClassName: "floating-label ", className: "custom-form-control", pattern: alphaNumExp, autofocus: true })),
                                            AccStorageuserID && (React.createElement(Dropdown.Menu, null,
                                                React.createElement(Dropdown.Item, null,
                                                    React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                                                        React.createElement("div", { onClick: () => setUserId(AccStorageuserID) },
                                                            React.createElement("p", { className: "EncodeSans_16_500 txt_primaryGrey" }, AccStorageuserID)),
                                                        React.createElement("div", null,
                                                            React.createElement("i", { className: "edel-icon-trash trash", onClick: () => {
                                                                    localStorage.clear();
                                                                    di.login.flushLoginError(); //confirmation bottom drawer on mobile
                                                                } })))))))),
                                    React.createElement("div", null,
                                        React.createElement("div", { className: "d-flex justify-content-between validations mt-0 mt-37" },
                                            !accountDetailsLoader &&
                                                accountDetailsError.isOpen &&
                                                loginButtonDisable &&
                                                HandleError(),
                                            React.createElement("div", null,
                                                React.createElement("label", { className: "borderedText" },
                                                    React.createElement(EdButton, { btnTyp: "link", className: "no_bg txt-midnight-blue DMSansNormal_12_400", onClick: () => {
                                                            di.login.flushLoginError();
                                                            if (props.helpFlowPopup) {
                                                                props.helpFlowPopup(loginScreenState.FORGOT_LOGIN_ID);
                                                            }
                                                            else {
                                                                navigate(handleNavigateUrl("/forgot-loginId", redirectUrlFromQueryParams), {
                                                                    replace: true,
                                                                });
                                                            }
                                                        }, type: "button", value: "Forgot login ID?" })))))),
                                React.createElement(Row, { className: "m-0" },
                                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Next", disabled: !userId || accountDetailsLoader || loginButtonDisable, type: "submit" })),
                                React.createElement(Row, { className: "clientLogin_unblockLink" },
                                    React.createElement(Col, { lg: 12, className: "d-flex justify-content-center" },
                                        React.createElement("div", null,
                                            React.createElement("p", { className: "txt_primaryGrey DMSanN_14_400 removecapitalize" },
                                                "Account blocked?\u00A0",
                                                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "small-edbutton", onClick: () => {
                                                        di.login.flushLoginError();
                                                        if (props === null || props === void 0 ? void 0 : props.helpFlowPopup) {
                                                            props.helpFlowPopup(loginScreenState.UNBLOCK_USER);
                                                        }
                                                        else {
                                                            navigate(handleNavigateUrl("/unblock-user", redirectUrlFromQueryParams), {
                                                                replace: true,
                                                            });
                                                        }
                                                    }, type: "button", value: "Click here to unblock" })))))),
                            React.createElement(Row, null,
                                React.createElement(Col, null,
                                    React.createElement("div", { className: "divider divider-15" },
                                        React.createElement("div", null,
                                            React.createElement("p", { className: "DMSanN_14_400 txt_primaryGrey" }, "Or"))))),
                            React.createElement(Row, { className: "m-0 deskBtn" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue", value: (device === null || device === void 0 ? void 0 : device.isDesktop) ? "Open an Account" : "Open an account", type: "button", className: "openAccnt", onClick: () => {
                                        window.open(config.accOpeningUrl);
                                    } }),
                                React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Continue as Guest", onClick: () => {
                                        setScreenState(loginScreenState.GUEST_LOGIN);
                                        if (device === null || device === void 0 ? void 0 : device.isDesktop) {
                                            props === null || props === void 0 ? void 0 : props.setTitle("Continue as Guest");
                                            props === null || props === void 0 ? void 0 : props.setParentClass("pb-125");
                                            navigate("/guest-login");
                                        }
                                        // if (
                                        //   redirectUrlFromQueryParams &&
                                        //   redirectUrlFromQueryParams !== "" &&
                                        //   redirectUrlFromQueryParams !== undefined &&
                                        //   redirectUrlFromQueryParams !== null
                                        // ) {
                                        //   navigate(
                                        //     "/guest-login" + redirectUrlFromQueryParams &&
                                        //       redirectUrlFromQueryParams !== ""
                                        //       ? "?redirectUrl=" + redirectUrlFromQueryParams
                                        //       : ""
                                        //   );
                                        // } else {
                                        //   navigate("/guest-login");
                                        // }
                                        di.login.flushLoginError();
                                    }, disabled: accountDetailsLoader || guestValidateMpin.status, type: "button" }))))));
            case loginScreenState.PASSWORD:
                return (React.createElement(LogInWelcomePage, { accType: accType, setAccType: setAccType, setScreenState: setScreenState, setOtpStateObj: setOtpStateObj, helpFlowPopup: props.helpFlowPopup, redirectUrl: redirectUrlFromQueryParams }));
            case loginScreenState.OTP:
                return (React.createElement(ClientLoginOtp, { otpStateObj: otpStateObj, accType: accType, redirectUrl: redirectUrlFromQueryParams, setScreenState: setScreenState, setAfterLogin: props === null || props === void 0 ? void 0 : props.setAfterLogin, helpFlowPopup: props.helpFlowPopup, skipRedirectNavigation: (props === null || props === void 0 ? void 0 : props.skipRedirectNavigation)
                        ? props === null || props === void 0 ? void 0 : props.skipRedirectNavigation
                        : false, parentCallBack: props.parentCallBack }));
            case loginScreenState.CHOOSE_ACCOUNT:
                return (React.createElement(ClientChooseLoginAccount, { setScreenState: setScreenState, setAccType: setAccType }));
            case loginScreenState.GUEST_LOGIN:
                return (React.createElement(GuestLogin, { skipRedirectNavigation: props === null || props === void 0 ? void 0 : props.skipRedirectNavigation, setAfterLogin: props === null || props === void 0 ? void 0 : props.setAfterLogin, setMainScreenState: setScreenState }));
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    React.useEffect(() => {
        if (!accountDetailsLoader && !accountDetailsError.isOpen) {
            if (accountDetails.accountTypesArray.length > 1) {
                setScreenState(loginScreenState.CHOOSE_ACCOUNT);
            }
            else if (accountDetails.accountTypesArray.length == 1) {
                if (di.login.getReturnLoginState()) {
                    setScreenState(loginScreenState.LOGIN);
                }
                else {
                    setScreenState(loginScreenState.PASSWORD);
                }
            }
        }
        else if (!accountDetailsLoader && accountDetailsError.isOpen) {
            setLoginDisable(true);
            setScreenState(loginScreenState.LOGIN);
        }
    }, [accountDetailsLoader, accountDetailsError, accountDetails]);
    React.useEffect(() => {
        let acc_data = JSON.parse(localStorage.getItem("acc_data"));
        if (acc_data)
            setAccStorageuserID(acc_data.userId);
        setScreenState(loginScreenState.LOGIN);
    }, []);
    React.useEffect(() => {
        if (screenState) {
            handleScreens();
        }
    }, [screenState]);
    return React.createElement(React.Fragment, null, handleScreens());
};
